export default __webpack_public_path__ + "static/media/letter.bf247488.svg";